<template>
  <div class="certifications-container">
    <!-- Bannière ou Titre -->
    <div class="header">
      <h1 class="title">Qualité & Certifications</h1>
      <p class="subtitle">Découvrez notre engagement envers la qualité et nos certifications.</p>
 
    </div>
     <div class="breadcrumb">
      <a href="/">Accueil</a> > <a href="/certification">Qui sommes-Nous</a> > <a href="/qualite-certifications">Qualité & certifications</a> 
    </div>
    <!-- Section Qualité -->
    
    <section class="quality-section">
      <h2 class="section-title">Notre engagement pour la qualité</h2>
      <p class="section-description">
        Chez Supracare, nous sommes déterminés à fournir des produits de la plus haute qualité. Nous nous conformons aux
        normes internationales pour garantir que chaque produit répond aux exigences de sécurité et de performance.
      </p>
      <ul class="quality-list">
         <div class="product">
          <img decoding="async" src="@/assets/MQA2.png" alt="Product 10">
           <img decoding="async" src="@/assets/iso.png" alt="Product 10">
           <img decoding="async" src="@/assets/qualite.png" alt="Product 10">
        </div>
        <li><strong>ISO 9001:</strong> Système de gestion de la qualité (En cours...)</li>
        <li><strong>ISO 13485:</strong> Normes de qualité pour les dispositifs médicaux.</li>
      </ul>
    </section>

    <!-- Section Certifications -->
    <section class="certifications-section">
      <h2 class="section-title">Nos Certifications</h2>
      <div class="certifications-gallery">
        <div v-for="(certification, index) in certifications" :key="index" class="certification-card">
          <img :src="certification.image" :alt="certification.name" class="certification-image" />
          <h3 class="certification-title">{{ certification.name }}</h3>
          <p class="certification-description">{{ certification.description }}</p>
        </div>
      </div>
    </section>
        <!-- Section Attestations -->
    <section class="certifications-section">
      <h2 class="section-title">Nos Attestations</h2>
      <div class="certifications-gallery">
        <div v-for="(attestations, index) in attestations" :key="index" class="certification-card">
          <img :src="attestations.image" :alt="attestations.name" class="certification-image" />
          <h3 class="certification-title">{{ attestations.name }}</h3>
          <p class="certification-description">{{ attestations.description }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
      name: "QualiteCertifications",
  data() {
    return {
      certifications: [
     
        {
          name: 'ISO 13485',
          image: require('@/assets/ISO13485.png'),
          description: 'Certification spécifique aux dispositifs médicaux'
        },
       
        /*
        {
          name: 'ISO 14001',
          image: require('@/assets/QR CERTIF.jpeg'),
          description: 'Certification de gestion environnementale.'
        },
        {
          name: 'CE Certification',
          image: require('@/assets/QR CERTIF.jpeg'),
          description: 'Certification européenne de conformité des produits.'
        }
          */
      ],

            attestations: [
          {
  
          image: require('@/assets/QRF1.png'),
          description: 'Attestation de régularité fiscale'
        },
        /*
        {
          name: 'ISO 14001',
          image: require('@/assets/QR CERTIF.jpeg'),
          description: 'Certification de gestion environnementale.'
        },
        {
          name: 'CE Certification',
          image: require('@/assets/QR CERTIF.jpeg'),
          description: 'Certification européenne de conformité des produits.'
        }
          */
      ]
    };
  }
};
</script>

<style scoped>
.certifications-container {
  padding: 0px 0px;
  background-color: #f9f9f9; 
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
}

.certifications-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); 
  z-index: -1;
}

.header {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77); 
  padding: 100px 400px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
  max-width: 1000px; 
  z-index: 1;
}

.title {
  font-size: 32px;
  color: #090c78;
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 50px;

}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3; /* Couleur au survol */
}

.subtitle {
  font-size: 18px;
  color: #555;
}

.quality-section,
.certifications-section {
  padding: 20px 200px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); 
  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif; 
}

.section-title {
  font-size: 28px;
  color: #090c78;
  margin-bottom: 20px;
}

.section-description {
  font-size: 18px;
  color: #333;
  line-height: 1.6;
}

.quality-list {
  list-style: none;
  padding: 0;
  margin: 20px 0;
}

.quality-list li {
  font-size: 18px;
  margin-bottom: 10px;
}

.certifications-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.certification-card {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  width: 250px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.certification-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.certification-image {
  width: 250px;
  height: auto;
  margin-bottom: 0px;
}

.certification-title {
  font-size: 20px;
  color: #090c78;
  margin-bottom: 10px;
}

.certification-description {
  font-size: 16px;
  color: #333;
}

/* Responsive Styles */
@media only screen and (max-width: 1040px) {
  .header {
    padding: 100px 50px; 
    font-size: 18px;
    max-width: 90%; 
    margin: 0 auto;
  }

  .quality-section,
  .certifications-section {
    padding: 20px 100px; 
  }

  .section-title {
    font-size: 24px; 
  }

  .section-description,
  .quality-list li {
    font-size: 16px; 
  }

  .certifications-gallery {
    flex-direction: column; 
    align-items: center;
  }

  .certification-card {
    width: 100%; 
  }
}

@media only screen and (max-width: 450px) {
  .header {
    font-size: 16px;
    max-width: 100%; 
  }

  .quality-section,
  .certifications-section {
    padding: 20px 30px; 
  }

  .section-title {
    font-size: 16px; 
  }

  .section-description,
  .quality-list li {
    font-size: 14px; 
  }

  .certifications-gallery {
    flex-direction: column;
    gap: 10px; 
  }

  .certification-card {
    width: 100%; 
    padding: 10px; 
  }

  .certification-image {
    width: 100px;
  
  }

  .certification-title {
    font-size: 14px; 
  }

  .certification-description {
    font-size: 14px; 
  }
}

/* ===================== MODE SOMBRE (auto) ===================== */
@media (prefers-color-scheme: dark){

  /* Fond global + voile sombre doux */
  .certifications-container{
    background:#0e1720;
    color:#e6edf1;
  }
  .certifications-container::before{
    background-color: rgba(0,0,0,0.35);
  }

  /* Bandeau image : lisibilité renforcée */
  .header{
    color:#e6edf1;
    box-shadow: 0 10px 32px rgba(0,0,0,.5);
    position: relative;
  }
  .header::after{
    content:""; position:absolute; inset:0; pointer-events:none; border-radius: inherit;
    background: linear-gradient(180deg, rgba(0,0,0,.45), rgba(0,0,0,.25));
  }

  .title{ color:#010a0a; }
  .subtitle{ color:rgb(52, 50, 50); }

  /* Fil d’Ariane */
  .breadcrumb{ color:#9fb3c8; }
  .breadcrumb a{ color:#73d8cf; }
  .breadcrumb a:hover{ color:#a5f3ee; }

  /* Sections (surfaces) */
  .quality-section,
  .certifications-section{
    background:#0f1720;
    border: 1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 24px rgba(0,0,0,.55);
  }
  .section-title{ color:#cde5ff; }
  .section-description{ color:#cfe0e4; }
  .quality-list li{ color:#cfe0e4; }

  /* Cartes de certification */
  .certification-card{
    background:#0f1a24;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 22px rgba(0,0,0,.5);
  }
  .certification-card:hover{
    transform: translateY(-10px);
    box-shadow: 0 14px 28px rgba(0,0,0,.55);
  }
  .certification-title{ color:#a5f3ee; }
  .certification-description{ color:#afc4c9; }
}

/* Micro-ajustement mobile en sombre */
@media (prefers-color-scheme: dark) and (max-width:1040px){
  .header{ box-shadow: 0 8px 22px rgba(0,0,0,.55); }
}

</style>